/* ImageTypeIconRenderer.js */

"use strict";
// const { IMAGE_TYPES_FILTER } = require("../../../../fileConstants");

class ImageTypeIconColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("image-type-icon-column");
        this._rootElem.component = this._model;

        this._imageIcon = document.createElement("base-icon-gl");

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._imageIcon.remove();
            this._imageIcon = undefined;

            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("ImageType", (this._onImageType = this._onImageType.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("ImageType");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        this._setImageType(this._model.getImageType());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onImageType(imageType) {
        this._setImageType(imageType);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setImageType(imageType) {
        this._updateIcon(imageType);
        this._rootElem.appendChild(this._imageIcon);
    }

    _updateIcon(imageType) {
        const imageTypeData = this._model._imageTypeFilter[imageType] || {};
        const icon = imageType ? imageType.split(" ")[0].toLowerCase() : undefined;
        this._imageIcon.title = imageTypeData.title || "Default";
        this._imageIcon.dataset.icon = icon
            ? `fileserver.image_type_${icon}`
            : "fileserver.image_type_default";
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ImageTypeIconColumnRenderer;
